import React from 'react';

import { useRefreshSimProdcutInventoryEntry } from 'src/products/sim/Inventory/hooks/useRefreshSimProductInventoryEntry';
import { SimProductsEditDialog } from 'products/sim/Edit/SimProductEditDialog';

export type SimProductsInventoryEditDialogDialogProps = {
  open: boolean;
  onClose: () => void;
  data: any;
};

export const SimProductsInventoryEditDialog = React.memo(
  (props: SimProductsInventoryEditDialogDialogProps) => {
    const { refreshTags, refreshCustomFields } = useRefreshSimProdcutInventoryEntry();

    if (!props.data) {
      return null;
    }

    return (
      <SimProductsEditDialog
        {...props}
        onTagsChange={refreshTags}
        onCustomFieldsChange={refreshCustomFields}
      />
    );
  },
);
